module.exports = __webpack_public_path__ + "static/media/ESCULTURA.8cca91ce.png";